import { isBoolean, isFunction, isString } from "../TypeChecking/index.js";
const INVALID_BID = "_fp_invalid";
const BID_SLOT_NAME = "video";
var apsInitPromise = null;
const videoBidSet = new Set([
    "v_1noy7sw", "v_far6kg", "v_11zbzls", "v_onvh8g", "v_1x22igw", "v_8v7k0", "v_18n28sg", "v_vblqf4",
    "v_1kukdmo", "v_cgdce8", "v_17j3v9c", "v_j43lkw", "v_1riamtc", "v_5sn37k", "v_1e6u4g0", "v_tno64g",
    "v_1oqeozk", "v_gc7nr4", "v_10befb4", "v_mzxwxs", "v_1ve4y68", "v_44piww", "v_1ciwk5c", "v_z7g1s0",
    "v_1j6mtc0", "v_asfs3k", "v_15v6ayo", "v_ki1khs", "v_1sw8lq8", "v_76l24g", "v_1fks3cw", "v_r5rtog",
    "v_1m8icjk", "v_dubbb4", "v_13d9yio", "v_q1tg5c", "v_1yg0hds", "v_1mt6gw", "v_1a107pc", "v_wpjpc0",
    "v_1kkks8w", "v_c6dr0g", "v_17949vk", "v_iu4074", "v_1r8b1fk", "v_5inhts", "v_1dwuj28", "v_v1m51c",
    "v_1q4cnwg", "v_hq5mo0", "v_11pce80", "v_odvvuo", "v_1ws2x34", "v_2bs5xc", "v_1apz75s", "v_xeiosg",
    "v_1hdpgcg", "v_8zif40", "v_1428xz4", "v_l70jy8", "v_nulmo", "v_t8os1s", "v_adge0w", "v_qgsu80",
    "v_4kxv5s", "v_xzqtq8", "v_f4ifpc", "v_jaccg0", "v_4ay9s0", "v_qn1l34", "v_bnnif4", "v_nv5n9c",
    "v_81ssg0", "v_vwtvcw", "v_fqzitc", "v_kqs7pc", "v_1vjtog", "v_uge03k", "v_9x81s0", "v_ohmqdc",
    "v_5meccg", "v_z17aww", "v_do2kg0", "v_inv9c0", "v_rxv6kg", "v_mo2wao", "v_x7ngu8", "v_lp4bgg",
    "v_tqsjk0", "v_psgbuo", "v_xu4jy8", "v_jyoutc", "v_rbe3gg", "v_npjdhc"
]);
const displayBidSet = new Set([
    "ypca9s", "ozqhvk", "uyhrls", "kex728", "v8hczk", "npjdhc", "rbe3gg", "jyoutc", "xu4jy8", "psgbuo",
    "tqsjk0", "lp4bgg", "x7ngu8", "amznbidz17aww", "rxv6kg", "inv9c0", "do2kg0", "z17aww", "5meccg",
    "ohmqdc", "9x81s0", "uge03k", "1vjtog", "kqs7pc", "fqzitc", "vwtvcw", "81ssg0", "nv5n9c", "bnnif4",
    "qn1l34", "4ay9s0", "jaccg0", "f4ifpc", "xzqtq8", "4kxv5s", "qgsu80", "adge0w", "t8os1s", "nulmo",
    "l70jy8", "1428xz4", "8zif40", "1hdpgcg", "xeiosg", "1apz75s", "2bs5xc", "1ws2x34", "odvvuo", "11pce80",
    "hq5mo0", "1q4cnwg", "v1m51c", "1dwuj28", "5inhts", "1r8b1fk", "iu4074", "17949vk", "c6dr0g", "1kkks8w",
    "wpjpc0", "1a107pc", "1mt6gw", "1yg0hds", "q1tg5c", "13d9yio", "dubbb4", "1m8icjk", "r5rtog", "1fks3cw",
    "76l24g", "1sw8lq8", "ki1khs", "15v6ayo", "asfs3k", "1j6mtc0", "z7g1s0", "1ciwk5c", "44piww", "1ve4y68",
    "mzxwxs", "10befb4", "gc7nr4", "1oqeozk", "tno64g", "1e6u4g0", "5sn37k", "1riamtc", "j43lkw", "17j3v9c",
    "cgdce8", "1kukdmo", "vblqf4", "18n28sg", "8v7k0", "1x22igw", "onvh8g", "11zbzls", "far6kg", "1noy7sw",
    "sm7oxs", "1h17ym8", "8n0xds", "1ucogzk", "lyhfr4", "14tpts0", "9qzaww", "1i56c5c", "y5zklc", "1bhg2yo",
    "3391q8", "1w0m1a8", "nmf01s", "10xvif4", "gyoqv4", "1pcvs3k", "ua598g", "1d5dn9c", "4r6m0w", "1qgu5mo",
    "i2n4e8", "16hne2o", "bewv7k", "1jt3wg0", "ws1log", "1a3i41s", "1pb2tc", "1yiidq8", "q4bchs", "13fruv4",
    "dwt7nk", "1mb08w0", "r89q0w", "1fn9zpc", "792ygw", "1syqi2o", "kkjgu8", "153pf5s", "a0ywao", "1if5xj4",
    "yfz5z4"
]);
function isWindowWithApstag(a) {
    return ("apstag" in a &&
        ("init" in a.apstag && isFunction(a.apstag.init)));
}
const APSTAG_CONFIG_URL = "https://config.aps.amazon-adsystem.com/configs";
const APSTAG_CLIENT_URL = "https://client.aps.amazon-adsystem.com/publisher.js";
function injectScript(src) {
    return new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.fetchPriority = "high";
        s.src = src;
        s.onload = () => resolve(src);
        s.onerror = () => reject(new Error("Failed to load: " + src));
        const x = document.getElementsByTagName('script')[0] || document.head || document.body;
        x.parentNode.insertBefore(s, x);
    });
}
async function ensureAPSLoaded(accountId, win) {
    if (win._apsLoaded && win.aps && win.apstag) {
        return;
    }
    if (!apsInitPromise) {
        apsInitPromise = loadAPS(accountId).then(() => {
            win._apsLoaded = true;
        });
    }
    return apsInitPromise;
}
async function loadAPS(accountId) {
    await Promise.all([
        injectScript(`${APSTAG_CONFIG_URL}/${accountId}`),
        injectScript(APSTAG_CLIENT_URL),
    ]);
    window.aps = addBootstrap(accountId);
    return { aps: window.aps, apstag: window.apstag };
}
function addBootstrap(accountId) {
    const aps = (function (e) {
        window._aps = window._aps || new Map();
        if (!window._aps.has(e)) {
            window._aps.set(e, { queue: [], store: new Map([["listeners", new Map()]]) });
        }
        const t = {
            accountID: String(e),
            record: function (evt, payload) {
                return new Promise((resolve, reject) => {
                    window._aps
                        .get(t.accountID)
                        .queue.push(new CustomEvent(evt, { detail: { ...(payload || {}), resolve, reject } }));
                });
            },
            read: function (name) {
                this.record("bootstrap/store/willRead", { name });
                return window._aps.get(this.accountID).store.get(name);
            },
            run: function (evt, payload) {
                const systemAps = window._aps.get("_system");
                if (systemAps && systemAps.store.get("listeners").has(evt)) {
                    this.record(evt, payload);
                }
                else {
                    this.record("bootstrap/run/willDrop", { name: evt, detail: payload });
                }
            },
            react: function (evt, handler) {
                window._aps.get(this.accountID).store.get("listeners").set(evt, handler);
                this.record("bootstrap/react/didExecute", { name: evt });
            },
        };
        t.record("bootstrap/version/declare", { version: 5 });
        return t;
    })(accountId);
    (function (t) {
        window.apstag = window.apstag || {
            init: (e, r) => t.record("legacy/init/enqueue", { config: e, callback: r }),
            fetchBids: (e, r) => t.record("legacy/fetchBids/enqueue", { bidConfig: e, callback: r }),
            setDisplayBids: () => t.run("legacy/setDisplayBids/enqueue", { arguments }),
            targetingKeys: () => t.read("legacy/targetingKeys") ?? [],
            rpa: (e, r, n) => t.record("legacy/rpa/enqueue", { tokenConfig: e, callback: r, setCookie: n }),
            upa: (e, r, n) => t.record("legacy/upa/enqueue", { tokenConfig: e, callback: r, setCookie: n }),
            dpa: (e) => t.record("legacy/dpa/enqueue", { callback: e }),
        };
        t.record("bootstrapExtAPStag/version/declare", { version: 1 });
    })(aps);
    (function (t) {
        window.apstag = {
            ...window.apstag,
            queue: { push: (cb) => t.record("legacy/queue/push", { callback: cb }) },
        };
        t.record("bootstrapExtQueue/version/declare", { version: 1 });
    })(aps);
    (function (t) {
        window.apstag = {
            ...window.apstag,
            customPlacements: () => ({
                hint: (id, isDefault, hintMetadata) => t.record("customPlacement/hint/define", { id, isDefault, hintMetadata }),
                enable: () => t.record("customPlacement/service/enable", {}),
                addEventListener: (evt, handler) => {
                    if (evt === "PlacementResponse") {
                        t.react("customPlacement/placement/didRespond", handler);
                    }
                    else {
                        throw new Error("Unsupported event type");
                    }
                },
            }),
        };
        t.record("bootstrapExtASR/version/declare", { version: 1 });
    })(aps);
    (function (t) {
        window.apstag = {
            ...window.apstag,
            nativeContent: () => ({
                enable: () => t.record("nativeCommerceAds/service/enable", {}),
                registerHook: (evt, handler) => {
                    if (evt === "nativeCommerceAds.updateClickUrl") {
                        t.react("nativeCommerceAds/clickUrl/update", (k) => ({
                            status: "completed",
                            value: { url: handler(k?.detail?.url, k?.detail?.element) },
                        }));
                    }
                    else {
                        throw new Error("Unsupported event type");
                    }
                },
            }),
        };
        t.record("bootstrapExtNCA/version/declare", { version: 1 });
    })(aps);
    window.aps = aps;
    console.log('[amz] bootstrap completato ', aps);
    return aps;
}
function isExternalBidVariables(x) {
    return (("_fp_amz_enabled" in x) && isBoolean(x._fp_amz_enabled)) &&
        x._fp_amz_enabled;
}
export function isInvalidBid(bidString) {
    return !isString(bidString) || bidString == INVALID_BID;
}
function getOrInitializeAPSTagSdk(window, userData, gdpr, config) {
    if (window._apsLoaded && isWindowWithApstag(window)) {
        return Promise.resolve(window.apstag);
    }
    if (isWindowWithApstag(window)) {
        if (!window.__apstagInited) {
            window.apstag.init(config, () => { window.__apstagInited = true; });
            window._apsLoaded = true;
        }
        return Promise.resolve(window.apstag);
    }
    return gdpr
        .then(gsdk => gsdk.amazon.allowPersonalizedAds() && gsdk.amazon.allowHeaderBidding())
        .then(async (amazonEnabled) => {
        if (!amazonEnabled)
            throw new Error("APSTAG NOT ENABLED");
        await ensureAPSLoaded(config.pubID, window);
        const apstag = window.apstag;
        if (!apstag || typeof apstag.init !== "function") {
            throw new Error("APS base bootstrap non disponibile: oggetto 'aps' o 'apstag' mancante");
        }
        if (!window.__apstagInited) {
            apstag.init(config, () => { window.__apstagInited = true; });
        }
        window._apsLoaded = true;
        if (!userData.isOptOut()) {
            const apat = userData.getApat();
            if (apat) {
                apstag.rpa({
                    hashedRecords: [{ type: "email", record: apat }],
                    optOut: false
                });
            }
        }
        return apstag;
    });
}
export const DefaultVideoBidSlot = {
    slotID: BID_SLOT_NAME,
    mediaType: "video",
};
export class AmazonHBBaseImpl {
    window;
    gdprPromise;
    userData;
    config;
    exportGlobalVideoBid;
    constructor(window, gdprPromise, userData, config, exportGlobalVideoBid) {
        this.window = window;
        this.gdprPromise = gdprPromise;
        this.userData = userData;
        this.config = config;
        this.exportGlobalVideoBid = exportGlobalVideoBid;
        if (this.exportGlobalVideoBid) {
            const exportVariables = {
                _fp_amz_enabled: true,
                _fp_amz_page_load: true,
                _fp_amz_scp: null
            };
            Object.keys(exportVariables).forEach(k => {
                this.window[k] = exportVariables[k];
            });
        }
    }
    loadSdk() {
        console.log('[SHATSU] LOAD SDK');
        return getOrInitializeAPSTagSdk(this.window, this.userData, this.gdprPromise, this.config);
    }
    fetchBids(slots) {
        const legacy = slots.filter(s => !s.videoSignals);
        const withSignals = slots.filter(s => s.videoSignals);
        return Promise.all([
            legacy.length ? this.fetchBidsLegacy(legacy) : Promise.resolve([]),
            withSignals.length ? this.fetchBidsWithSignals(withSignals) : Promise.resolve([])
        ]).then(([legacyBids, modernBids]) => {
            const allBids = [...legacyBids, ...modernBids];
            allBids.forEach(bid => {
                if (!bid)
                    return;
                const bidId = bid['amznbid'];
                if (videoBidSet.has(bidId)) {
                    bid['amz_high_yield'] = 'video';
                }
                else if (displayBidSet.has(bidId)) {
                    bid['amz_high_yield'] = 'display';
                }
                else {
                    bid['amz_high_yield'] = 'no';
                }
            });
            return allBids;
        });
    }
    fetchBidsLegacy(s) {
        const exportVideoBid = this.exportGlobalVideoBid && s.some(slot => slot.mediaType && slot.mediaType == "video");
        return this.loadSdk().then(sdk => {
            return new Promise((resolve) => {
                sdk.fetchBids({ slots: s }, (bids) => {
                    if (exportVideoBid) {
                        let encodedQS = null;
                        if (bids) {
                            const updatedExportParams = {
                                _fp_amz_enabled: true,
                                _fp_amz_scp: INVALID_BID,
                                _fp_amz_page_load: false
                            };
                            const videoBid = bids.find(bid => bid.mediaType == "video");
                            if (videoBid) {
                                if (videoBid.encodedQsParams) {
                                    encodedQS = videoBid.encodedQsParams;
                                }
                                else if (videoBid.helpers?.encodedQsParams) {
                                    encodedQS = videoBid.helpers.encodedQsParams();
                                }
                                updatedExportParams._fp_amz_scp = encodedQS;
                            }
                            Object.keys(updatedExportParams).forEach(k => {
                                this.window[k] = updatedExportParams[k];
                            });
                        }
                    }
                    resolve(bids);
                });
            });
        });
    }
    async fetchBidsWithSignals(slots) {
        await ensureAPSLoaded(this.config.pubID, this.window);
        const w = this.window;
        if (!w.aps) {
            throw new Error("[amz] APS non inizializzato correttamente");
        }
        for (const s of slots) {
            const sig = s.videoSignals;
            await w.aps.record("ad/slot/define", {
                imp: [{
                        id: s.slotID,
                        video: {
                            startdelay: sig.startdelay ?? 0,
                            plcmt: sig.plcmt ?? 1,
                            pos: sig.pos ?? 0,
                            w: sig.w,
                            h: sig.h
                        }
                    }]
            });
        }
        await w.aps.record("ad/targeting/fetch", { itemIds: slots.map(s => s.slotID) });
        const store = w.aps.read("ad/targeting");
        return slots.map(s => {
            const pairs = store?.get(s.slotID) ?? [];
            const targeting = {};
            for (const [k, v] of pairs)
                targeting[k] = v;
            const qs = Object.entries(targeting)
                .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
                .join("&");
            return {
                slotID: s.slotID,
                mediaType: "video",
                targeting,
                encodedQsParams: qs,
                helpers: {
                    encodedQsParams: () => qs
                }
            };
        });
    }
    getExternalVideoBid() {
        const w = this.window;
        const timeout = this.config.bidTimeout;
        if (isExternalBidVariables(w)) {
            const cleanAndGet = () => {
                const flag = w._fp_amz_scp;
                w._fp_amz_scp = null;
                w._fp_amz_page_load = false;
                return flag;
            };
            if (w._fp_amz_page_load) {
                const startTime = new Date().getTime();
                return new Promise((resolve, reject) => {
                    const rec = () => {
                        if (w._fp_amz_scp && w._fp_amz_scp.trim().length > 0) {
                            if (w._fp_amz_scp != INVALID_BID)
                                resolve(cleanAndGet());
                            else
                                reject("invalid external bid");
                        }
                        else {
                            if (new Date().getTime() - startTime >= timeout) {
                                return reject("external bid search timeout");
                            }
                            else
                                w.setTimeout(rec, 50);
                        }
                    };
                    rec();
                });
            }
            else {
                if (w._fp_amz_scp && w._fp_amz_scp.trim().length > 0 && w._fp_amz_scp != INVALID_BID) {
                    return Promise.resolve(cleanAndGet());
                }
                else {
                    return Promise.resolve(null);
                }
            }
        }
        return Promise.resolve(null);
    }
}
